// extracted by mini-css-extract-plugin
module.exports = {"Loader":"SmallSpinnerDark_Loader__3dMdU","load7":"SmallSpinnerDark_load7__Hv27-"};